<div class="top-container px-4">
  <div class="row">
  <div class="col-sm-12">
    <div class="buttons-container">
      <!-- Left buttons for workflow definition -->

      <div class="button-wrapper mr-4 d-inline" [matTooltip]="'You can\'t apply a workflow if all tasks are disabled.'" [matTooltipDisabled]="!areAllTasksDisabled()">
        <button *ngIf="workflowDefinition" class="btn btn-success" mat-flat-button (click)="openApplyWorkflowModal()" [disabled]="areAllTasksDisabled()"
        >
        <!--     [disabled]="areAllTasksDisabled()" -->
        <!--  -->
          <i class="fa fa-gears"></i>
          Apply Workflow
        </button>
      </div>

      <button *ngIf="workflowDefinition" class="mb-4 main-btn mr-4" mat-flat-button (click)="openNewTaskDefinitionModal()">
        <i class="fa fa-plus"></i>
        Add Task
      </button>
      <button *ngIf="workflowDefinition" class="mb-4 mr-4 btn main-btn w-auto" mat-flat-button disabled>
        <i class="fa fa-search"></i>
        See all resources having this workflow
      </button>

      <!-- Messages -->
      <span class="alert alert-light" *ngIf="workflowInstance">
        You {{mostRelevantTask[0]?.active === true ? 'have' : 'don\'t have any'}} pending actions.
      </span>

      <!-- Right controls -->
      <button *ngIf="workflowInstance && role === 'Lasgro Admin'" type="button" class="btn btn-sm btn-light pull-right border" (click)="openHelpModal()">
        <i class="fa fa-ellipsis-h"></i>
      </button>
      <button type="button" class="btn btn-sm btn-light pull-right border mr-4" (click)="openHelpModal()">
        <i class="fa fa-question-circle"></i>
        Help
      </button>
      <button type="button" class="btn btn-sm btn-light pull-right border mr-4" (click)="toggleDualView()">
        <i class="fa fa-toggle-on text-success" *ngIf="isDualViewEnabled"></i>
        <i class="fa fa-toggle-off" *ngIf="!isDualViewEnabled"></i>
        Double timeline
      </button>
      <mat-form-field class="pull-right w-auto m-0 mr-4">
        <mat-select placeholder="Jump to..." (selectionChange)="jumpToIndex($event.value)" [(ngModel)]="focusedTaskIndex">
          <mat-option *ngIf="mostRelevantTask.length > 0" [value]="mostRelevantTask[0].order">
            Most relevant task
          </mat-option>
          <mat-option *ngFor="let task of tasks" [value]="task.order">
            ({{ task.order + 1 }}) {{ task.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  </div>
</div>

<div class="timeline-container p-4">
<ngx-loading [show]="loading"></ngx-loading>
<div class="row">
<div class="col-sm-12">

<div [ngClass]="{'single': !isDualViewEnabled, 'dual': isDualViewEnabled}" class="timeline" *ngIf="tasks.length">

  <div class="timeline-nav">
    <div class="timeline-nav-button left" (click)="navMove($event)" *ngIf="currentPosition < startPosition"></div>
    <div class="timeline-nav-button right" (click)="navMove($event)" *ngIf="tasks.length > 1 && !isLastTaskVisible()"></div>
  </div>

  <div class="timeline-container" [style.transform]="'translate3d(' + currentPosition + 'px, 0px, 0)'" style="    padding: 20px;">

    <div id="t-{{index}}" class="timeline-card task t-{{index}} d-flex flex-column justify-content-start" 
      *ngFor="let task of tasks; let index = index" 
      (click)="openTaskModal(task, index)" 
      [ngClass]="{
        'inactive': workflowInstance && !task.active, 
        'active': workflowInstance && (task.active || task.instance_id === mostRelevantTask[0]?.instance_id),
        'border-success': task.status === 'COMPLETED',
        'completed': task.status === 'COMPLETED',
        'border-primary': task.instance_id === mostRelevantTask[0]?.instance_id
      }">
        <!-- 'highlight': task.instance_id === mostRelevantTask[0]?.instance_id -->

      <i class="task-options fa fa-ellipsis" *ngIf="role === 'Lasgro Admin'"></i>

      <div id="task-name" class="name mb-3 pb-1" [matTooltip]="task.name" [matTooltipDisabled]="!isTextOverflow('task-name')">
        {{task.name}}
      </div>

      <div class="due-date mb-1">
          <i class="fa fa-calendar pr-1" [ngClass]="{'text-danger': isTaskExpired(task)}"></i>
          <span *ngIf="workflowDefinition"
            [matTooltip]="'Selected date already expired'"
            [matTooltipDisabled]="!isTaskExpired(task)"
            [ngClass]="{'text-danger': isTaskExpired(task)}"
          >
            Due {{ task.due_date_meta.specific_date ? (getRelativeDateString(task.due_date_meta) | date: 'MM/dd/yyyy':'utc') : getRelativeDateString(task.due_date_meta) }}
          </span>
          <span *ngIf="workflowInstance" [ngClass]="{'text-danger': isTaskExpired(task)}">
            {{isTaskExpired(task) ? 'Expired' : 'Due date:'}} {{task.due_date | date: 'MM/dd/yyyy':'utc' || 'N/A'}}
          </span>
          <span class="status badge badge-pill pull-right" *ngIf="workflowInstance" [ngClass]="{
            'badge-warning': task.status === 'PENDING' && !isTaskExpired(task),
            'badge-danger': task.status === 'PENDING' && isTaskExpired(task),
            'badge-success': task.status === 'COMPLETED',
            'badge-success': task.status === 'APPROVED',
            'badge-danger': task.status === 'REJECTED'
          }">
            <i class="fa fa-warning" *ngIf="task.status === 'PENDING' && isTaskExpired(task)"></i>
            {{task.status}}
          </span>
      </div>

      <div class="responsible mb-2" *ngIf="workflowInstance" [matTooltip]="'Responsible: '
        .concat(
          task.responsible.name, 
          ' (', 
          task.responsible.organization_name, 
          ')'
        )" >
          <i class="fa fa-user-circle-o pr-1"></i>
          <span>
            {{task.responsible.name}} 
          </span>
      </div>
      <div class="responsible mb-2" *ngIf="workflowDefinition">
          <i class="fa fa-user-circle-o pr-1" [ngClass]="{'text-success': task.default_responsible_id}"></i>
          <span>
            {{task.default_responsible_id ? 'Assigned' : 'Not assigned'}}
          </span>
      </div>

      <!-- <p id="task-description" class="description mb-2" [matTooltip]="task.description" [matTooltipDisabled]="!isTextOverflow('task-description')">
        {{task.description | markdown }}
      </p> -->
      <div markdown [data]="task.description" id="task-description" class="description mb-2"></div>


      <div *ngIf="workflowDefinition" class="type mb-3 mt-auto mr-auto">
        <span class="badge badge-pill badge-secondary" [matTooltip]="'Task type'">
          {{task?.task_type?.name || 'N/A'}}
        </span>
        <span class="badge badge-pill badge-info" *ngIf="workflowDefinition">
          For: {{task.intended_for_role === 'customers' ? 'Customer' : 'Vendor' }}
        </span>
      </div>

      <div *ngIf="workflowDefinition" class="icons d-flex justify-content-center">
        <i class="fa fa-toggle-on text-success" *ngIf="task.is_enabled" [matTooltip]="'Enabled'"></i>
        <i class="fa fa-toggle-off" *ngIf="!task.is_enabled" [matTooltip]="'Disabled'"></i>

        <i class="fa fa-users" *ngIf="task.allow_anyone_to_complete" [matTooltip]="'Anyone can complete'"></i>
        <i class="fa fa-user" *ngIf="!task.allow_anyone_to_complete" [matTooltip]="'Only responsible can complete'"></i>

        <!-- <i class="fa fa-id-badge" *ngIf="task.intended_for_role" [matTooltip]="'Meant to be completed by ' + task.intended_for_role"></i> -->

        <i class="fa fa-check-square" *ngIf="task.affected_task" [matTooltip]="'Approval task'"></i>

        <i class="fa fa-level-down" *ngIf="task.depends_on_task" [matTooltip]="'Depends on another task'"></i>

      </div>

      <div *ngIf="workflowInstance" class="actions mt-auto d-flex flex-row justify-content-end">

        <input type="file" class="d-none" id="file-input-{{index}}" (click)="$event.stopPropagation()" (change)="completeTaskWithFile($event, task)">

        <mat-form-field id="entity-value-{{index}}" class="m-0 d-inline-block w-auto"
          *ngIf="task.task_type.interaction_type === 'submit' && !task.completed_by"
          (click)="$event.stopPropagation()"
          style="margin: 0 !important;"
          [matTooltip]="'Use this quick-input box only for short inputs. If you need to provide larger data, click the task to open the task window.'"
          [matTooltipDisabled]="!task.active"
          [(ngModel)]="ctaFieldValues['entity-value-' + index]"
          ngDefaultControl>
          <input placeholder="Type here..." 
              maxlength="35" 
              [disabled]="!task.active" 
              autocomplete="off"
              name="entity-value-{{index}}"
              matInput/>
        </mat-form-field>

        <div class="btn-wrapper p-0 m-0" [matTooltip]="getCtaButtonTooltip(task)">
          <button type="button" class="btn" 
            *ngIf="!task.completed_by && task.task_type.interaction_type"
            [disabled]="!task.active"
            [ngClass]="{'btn-success': task.active, 'btn-secondary': !task.active}"
            (click)="handleCtaButtonClick($event, task, index, task.task_type.interaction_type === 'simple')"
            style="white-space: nowrap; height: 100%;">
            <i class="fa fa-lock" *ngIf="!task.active"></i>
            {{task.task_type.action_cta | uppercase}}
          </button>
        </div>

        <small *ngIf="task.completed_by">
          Completed by {{task.completed_by.name}} ({{task.completed_by.organization_name}}) at {{task.completed_at | date:'MM/dd/yyyy HH:mm':getUserTimezone()}}
        </small>

      </div>

      <svg class="timeline-card-svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M5 15h3v21H5V15zm1.5-2a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13z" fill="black"></path></svg>

    </div>

  </div>

</div>

<div class="no-tasks m-4" *ngIf="!tasks.length">
  <h3 class="my-4">Nothing to show, yet.</h3>
</div>

</div>
</div>
</div>